import React from "react";
import logo from '../images/logo.png'



function Navbar() {

  return (
    <div>
<nav className="navbar navbar-expand-lg navbar-dark bg-warning h-10">
  <div className="container d-flex flex-column flex-md-row  text-center">
    {/**/}
    <img src={logo} alt="Logo" style={{ height: "50px", marginBottom: "5px",width:"50px",borderRadius:"50px" }} className="col-md-2"/>
    <h6 className="text-dark fw-bold text-wrap mb-0 mx-2 col-md-10" 
        style={{ maxWidth: "100%", wordWrap: "break-word" }}>
          
      पुण्यश्लोक आहिल्यादेवी होळकर त्रिशताब्दी जयंती महोत्सव समिती, महाराष्ट्र राज्य
    </h6>
  </div>
</nav>


    </div>

  );
}

export default Navbar;
